import { Directive, forwardRef, Attribute, Input } from '@angular/core';
import { NG_VALIDATORS,Validator,
         Validators,AbstractControl,ValidatorFn } from '@angular/forms';
 
@Directive({
    selector: '[confirm]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: EqualValidatorrirective, multi: true }
    ]
})
export class EqualValidatorrirective implements Validator {
    @Input() confirm:string;
    //constructor( @Attribute('validateEqual') public validateEqual: string) {}
 
 
    validate(control: AbstractControl): { [key: string]: any } | null {
        console.log("a");
        const controltocompare=control.parent.get(this.confirm);
        if(controltocompare && controltocompare.value!==control.value){
            return {'notEqual':true}
        }
        return null;
    }
}




// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/register/passwordIgual.directive.ts